module.exports = __webpack_public_path__ + "static/Kollektif-Bold-04c38a99d8afcbb092591a7a88a39a88.ttf";